import Statement from "./components/Statement.vue";

export default {
  routes: [
    {
      path: "/:id?",
      component: Statement,
      name: "ApplicantStatement",
    },
  ],
};
